export class RegistrationVerify {
  id: string;
  declarationNumber: string;
  createdDate: Date;
  expectedDeliveryDate: Date;
  expectedDeliveryHour: string;
  codeType: string;
  enterpriseName: string;
  productName: string;
  countProduct: number;
  address: string;
  receiverName: string;
  receiverPhone: string;
  verifyName: string;
  feedbackInformation: string;
  note: string;
  createdBy: string;
  checked: boolean;
}
